import React from 'react';

const EmojiMessage = props => {
  return <div className="sc-support-message--emoji">{props.message}</div>;
};

export default EmojiMessage;
